import styled from 'styled-components';

export const ActionButtonStyled = styled.div`
  padding: ${props => props.theme.size.rap};
`;
